<div>
  <!-- <span> {{ baseCompanyCountryCd }}</span> -->
  <h3 id="payerId" class="heading" style="margin-bottom: 0px">Bank Details of {{bankBeneficiaryRole}}</h3>
  <nz-tabset [nzSize]="'large'">
    <ng-container *ngFor="let data of payeeList; let payeeIndex=index; ">
      <ng-template #titleTmplBankNominee>
        <strong class="d-b">Payer {{payeeIndex+1}}: {{data?.clientDO?.personDO?.firstName}}
          {{data?.clientDO?.personDO?.lastName}}</strong>
        <p class="col-green m-b-5">
          Bank details added
          <!-- <button nz-button nzType="primary" class="w-100-pc b-r-0" (click)="askAllChildrenForData()"><i nz-icon nzType="safety"
                nzTheme="outline"></i> Ask data</button> -->
        </p>
      </ng-template>
      <nz-tab [nzTitle]="titleTmplBankNominee">
        <div class="text-a-right">
          <button nz-button nzType="primary" (click)="addNewBankForm()">Add Bank</button>
        </div>
        <div class="card-container">
          <nz-tabset nzType="card" [nzSelectedIndex]="enableSpecificBankTab">
            <nz-tab *ngFor="let bankData of bankDataList; let indx = index;" [nzTitle]="'Bank '+ (indx+1)">
  
              <div class="m-b-20" style="width:400px;">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Purpose</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select nzShowSearch nzAllowClear nzMode="multiple" nzPlaceHolder="Select Purpose" [(ngModel)]="bankDataList[indx]['bankFormPurpose']" (ngModelChange)="updateBankPurpose($event,indx)">
                      <nz-option *ngFor="let item of (lookup$.AccountPurpose | async) as purposeCd; trackBy:item?.lookupKey"
                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item >
              </div>
              
  
              <!-- Bank Details Form -->
              <div>  
                <form *ngIf="baseCompanyCountryCd == 'INDIA'" [formGroup]="claimsBankDetailsForm">
                  <div class="bank-details-nominee-tab">
                    <div class="heading-tab m-t-10 m-b-20">
                      <!-- <h3 class="heading">Account Details: {{claimsBankDetailsForm.get('accountHolderName').value}}</h3> -->
                      <h3 class="heading">Account Details</h3>
                    </div>
                
                    <div class="tab-grid">
                      <nz-form-item style="align-content: flex-start;">
                        <nz-form-label [nzSpan]="24">Bank Account No</nz-form-label>
                        <nz-form-control [nzSpan]="24" class="m-b-10">
                          <input nz-input formControlName="accountNum" (ngModelChange)="onAccNoChange($event,'EVENT', data?.guid)" type="password" (focus)="formDataChangeHandler('accountNum')" (ngModelChange)="formDataChangeHandler('accountNum')"/>
                
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('accountNum').dirty || claimsBankDetailsForm.get('accountNum').touched) && claimsBankDetailsForm.get('accountNum').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('accountNum'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                
                        </nz-form-control>
                          <small class="d-b">Retype Bank Account No</small>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="retypeaccountNum" (ngModelChange)="onAccNoChange($event,'RETYPE')" />
                            <nz-form-explain *ngIf="accNoCheck == false">
                              <p style="color:red">
                                Bank Account No and Retype Bank Account No is not matched
                              </p>
                            </nz-form-explain>
                
                          </nz-form-control>
                      </nz-form-item>
  
                      <nz-form-item style="align-content: flex-start;">
                        <nz-form-label [nzSpan]="24">Account Holder Name</nz-form-label>
                        <nz-form-control [nzSpan]="24" class="m-b-10">
                          <input nz-input formControlName="accountHolderName" (ngModelChange)="onNameChange($event,'EVENT')" type="password" (focus)="formDataChangeHandler('accountHolderName')" (ngModelChange)="formDataChangeHandler('accountHolderName')" />
                
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('accountHolderName').dirty || claimsBankDetailsForm.get('accountHolderName').touched) && claimsBankDetailsForm.get('accountHolderName').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('accountHolderName'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                
                        </nz-form-control>
                
                          <small class="d-b">Retype Account Holder Name</small>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="retypeAccountHolderName" (ngModelChange)="onNameChange($event,'RETYPE')" />
                            <nz-form-explain *ngIf="accNameCheck == false">
                              <p style="color:red">
                                Account Holder Name and Retype Account Holder Name is not matched
                              </p>
                
                            </nz-form-explain>
                          </nz-form-control>
                      </nz-form-item>
                      <nz-form-item style="align-content: flex-start;">
                        <nz-form-label [nzSpan]="24">Payment Method</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <nz-select nzShowSearch id="paymentMethodCd" formControlName="paymentMethodCd" style="width: 100%"(focus)="formDataChangeHandler('paymentMethodCd')" (ngModelChange)="formDataChangeHandler('paymentMethodCd')">
                            <nz-option
                              *ngFor="let item of (lookup$['paymentMethodCd'] || [] | async) as paymentMethodCd; trackBy:item?.lookupKey"
                              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                          </nz-select>
                
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('paymentMethodCd').dirty || claimsBankDetailsForm.get('paymentMethodCd').touched) && claimsBankDetailsForm.get('paymentMethodCd').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('paymentMethodCd'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                
                    <!-- <div class="heading-tab">
                      <h3 class="heading">Bank Details: {{forWhom}}</h3>
                      <button nz-button nzType="primary" (click)="modSearchBank=true;">Search Bank</button>
                    </div> -->
                    <div class="tab-grid">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24"> IFSC</nz-form-label>
                        <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
                          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                            <input type="text" nz-input placeholder="IFSC Code" formControlName="branchIdNum1" (ngModelChange)="verifyIFSCCode()" (focus)="formDataChangeHandler('branchIdNum1')" (ngModelChange)="formDataChangeHandler('branchIdNum1')" />
                          </nz-input-group>
                          <ng-template #suffixIconButton>
                            <button (click)="fetchFromIFSC()" nz-button nzType="primary" class="d-b w-100-pc" [disabled]="!isIFSCVerified">
                              <i nz-icon nzType="search"></i>
                            </button>
                          </ng-template>
                        </nz-form-control>
                      </nz-form-item>
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">MICR</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="branchIdNum2" (focus)="formDataChangeHandler('branchIdNum2')" (ngModelChange)="formDataChangeHandler('branchIdNum2')"/>
                        </nz-form-control>
                      </nz-form-item>
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Name of Bank</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="bankName" (focus)="formDataChangeHandler('bankName')" (ngModelChange)="formDataChangeHandler('bankName')" />
                        </nz-form-control>
                      </nz-form-item>
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Branch</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input value="" formControlName="bankBranchName" (focus)="formDataChangeHandler('bankBranchName')" (ngModelChange)="formDataChangeHandler('bankBranchName')"/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <!-- <nz-form-item *ngIf="state == 'proposal'" style="align-content: flex-start;">
                        <nz-form-label [nzSpan]="24">Transaction Number</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="transactionNumber" />
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('paymentMethodCd').dirty || claimsBankDetailsForm.get('paymentMethodCd').touched) && claimsBankDetailsForm.get('paymentMethodCd').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('paymentMethodCd'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                        </nz-form-control>
                      </nz-form-item> -->
                      <!-- <nz-form-item>
                        <nz-form-label [nzSpan]="24">Address</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <textarea nz-input placeholder="Address" [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                            formControlName="address"></textarea>
                        </nz-form-control>
                      </nz-form-item>
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">City</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="cityCd" />
                        </nz-form-control>
                      </nz-form-item> -->
                    </div>
                
                
                    <!-- Document Manager: MINI mode (Must pass requirementCd && clientRefGuid: data is filtered based on these) -->
                    <!-- <app-document-manager [mode]="'mini'" [requirementCd]="'ACCOUNT_PROOF_NOMINEE'" [heading]="'Upload Cheque/Passbook'"
                      [clientRefGuid]="_inputDataForEdit.clientRefGuid" [clientDO]="_inputDataForEdit.clientDO"
                      [ocrVerification]="OCRverificationData" [requirements]="[]" [inputDataForEdit]="[]"
                      [RequirementEntityGuid]="entityGuid">
                    </app-document-manager> -->
                    <!-- /Document Manager -->
                
                
                  </div>
                
                
                
                
                  <!-- Search CUSTOMER -->
                  <nz-modal [(nzVisible)]="modSearchBank" nzTitle="Search Bank" (nzOnCancel)="modSearchBank=false"
                    (nzOnOk)="modSearchBank=false;fetchBankDetails()" nzOkText="Select" nzWidth="75%">
                    <ng-container *nzModalContent>
                    <div *ngIf="modSearchBank">
                      <div class="search-fields m-t-20">
                        <!-- Customer Search -->
                        <div>
                          <div class="tab-grid">
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">Branch Name</nz-form-label>
                              <nz-form-control [nzSpan]="24">
                                <input nz-input formControlName="bankBranchName" />
                              </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">Bank Name</nz-form-label>
                              <nz-form-control [nzSpan]="24">
                                <input nz-input formControlName="bankName" />
                              </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">City</nz-form-label>
                              <nz-form-control [nzSpan]="24">
                                <input nz-input formControlName="cityCd" />
                              </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">IFSC Code</nz-form-label>
                              <nz-form-control [nzSpan]="24">
                                <input nz-input formControlName="ifscCd" />
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </div>
                
                        <div class="multisearch-grid">
                          <div>
                            <button nz-button nzType="primary" (click)="searchBanks()">
                              Search Banks
                            </button>
                          </div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                      <div class="search-results m-t-20">
                        <!-- Customer Search Results -->
                        <div>
                          <nz-table *ngIf="bankDataSet && bankDataSet.length > 0" #bankSearchTable [nzData]="bankDataSet"
                            [nzSize]="'middle'" [nzShowPagination]="true">
                            <thead>
                              <tr>
                                <th></th>
                                <th>Bank</th>
                                <th>Branch</th>
                                <th>Address</th>
                                <th>IFSC</th>
                              </tr>
                            </thead>
                            <tbody>
                
                              <tr *ngFor="let data of bankSearchTable.data">
                                <td>
                                  <!-- <nz-radio-group >
                                  <label nz-radio nzValue="data.bankBranchName"(click)="handleChange($event,data.bankId)"></label>
                                </nz-radio-group> -->
                                  <input type="radio" name="test" (change)="handleChange($event,data)">
                                </td>
                                <td>{{data.bankName}}</td>
                                <td>{{data.bankBranchName}}</td>
                                <td>{{data.cityCd}}</td>
                                <td>{{data.ifscCd}}</td>
                              </tr>
                            </tbody>
                          </nz-table>
                        </div>
                      </div>
                    </div>
                    </ng-container>
                  </nz-modal>
                
                </form>
                
                <form *ngIf="baseCompanyCountryCd == 'HONGKONG'" [formGroup]="claimsBankDetailsForm">
                  <div class="bank-details-nominee-tab">
                    <div class="heading-tab">
                      <h3 class="heading">Account Details: {{claimsBankDetailsForm.get('accountHolderName').value}}</h3>
                    </div>
                    <div class="tab-grid">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Name Of Account Holder</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="accountHolderName" (ngModelChange)="onNameChange($event,'EVENT')" />
                    
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('accountHolderName').dirty || claimsBankDetailsForm.get('accountHolderName').touched) && claimsBankDetailsForm.get('accountHolderName').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('accountHolderName'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                        </nz-form-control>
                      </nz-form-item>
                    
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Retype Name Of Account Holder</nz-form-label>
                        <!-- <small class="d-b">Retype Name Of Account Holder</small> -->
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="retypeAccountHolderName" (ngModelChange)="onNameChange($event,'RETYPE')" />
                          <nz-form-explain *ngIf="accNameCheck == false">
                            <p style="color:red">
                              Account Holder Name and Retype Account Holder Name is not matched
                            </p>
                    
                          </nz-form-explain>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                
                    <div class="tab-grid">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Payment Method</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <!-- <nz-select nzShowSearch id="paymentMethodCd" formControlName="paymentMethodCd" style="width: 100%">
                                <nz-option
                                  *ngFor="let item of (lookup$['paymentMethodCd'] || [] | async) as paymentMethodCd; trackBy:item?.lookupKey"
                                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                              </nz-select> -->
                          <nz-radio-group formControlName="paymentMethodCd" nzButtonStyle="solid">
                            <label nz-radio-button nzValue="FPS">FPS</label>
                            <label nz-radio-button nzValue="E-BANKING">e-Banking</label>
                          </nz-radio-group>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                
                      
                      <div class="tab-grid" *ngIf="claimsBankDetailsForm.get('paymentMethodCd').value == 'FPS'">
                        <div>
                          <nz-radio-group formControlName="FPSPaymentMethod">
                            <label nz-radio nzValue="EMAIL">Email</label>
                            <label nz-radio nzValue="FPS-IDENTIFIER">FPS Identifier</label>
                            <label nz-radio nzValue="MOBILE">Mobile Number</label>
                          </nz-radio-group>
                        </div>
                
                        <div>
                          <nz-form-item *ngIf="claimsBankDetailsForm.get('FPSPaymentMethod').value == 'EMAIL'">
                            <nz-form-label [nzSpan]="24">Email</nz-form-label>
                            <nz-form-control [nzSpan]="24">
                              <input nz-input formControlName="email" placeholder="Email"/>
                            </nz-form-control>
                          </nz-form-item>
                          <nz-form-item *ngIf="claimsBankDetailsForm.get('FPSPaymentMethod').value == 'FPS-IDENTIFIER'">
                            <nz-form-label [nzSpan]="24">FPS Identifier</nz-form-label>
                            <nz-form-control [nzSpan]="24">
                              <input nz-input formControlName="FPSIdentifier" placeholder="FPS Identifier"/>
                            </nz-form-control>
                          </nz-form-item>
                          <nz-form-item *ngIf="claimsBankDetailsForm.get('FPSPaymentMethod').value == 'MOBILE'">
                            <nz-form-label [nzSpan]="24">Mobile Number</nz-form-label>
                            <nz-form-control [nzSpan]="24">
                              <div class="mobileSec">
                                <nz-select nzShowSearch formControlName="countryCode" style="width: 80px;">
                                  <nz-option nzLabel="+852" nzValue="HK"></nz-option>
                                  <nz-option nzLabel="+65" nzValue="SG"></nz-option>
                                  <nz-option nzLabel="+91" nzValue="IN"></nz-option>
                                </nz-select>
                                <!-- <input nz-input formControlName="mobile" placeholder="mobile"/> -->
                                <nz-input-number formControlName="mobile" [nzMin]="0000000000" [nzMax]="9999999999" [nzStep]="1" style="width:100%"></nz-input-number>
                              </div>
                            </nz-form-control>
                          </nz-form-item>
                
                        </div>
                      </div>
                
                
                      <div *ngIf="claimsBankDetailsForm.get('paymentMethodCd').value == 'E-BANKING'" class="tab-grid">
                        <div>
                          <nz-form-label [nzSpan]="24">Bank Number</nz-form-label>
                          <nz-form-control [nzSpan]="24">
                            <!-- <input nz-input formControlName="bankNumber" placeholder="Bank Number" /> -->
                            <nz-input-number formControlName="bankNumber" [nzMin]="000" [nzMax]="999" [nzStep]="1" style="width:100%"></nz-input-number>
                          </nz-form-control>
                        </div>
                        <div>
                          <nz-form-label [nzSpan]="24">Branch Number</nz-form-label>
                          <nz-form-control [nzSpan]="24">
                            <!-- <input nz-input formControlName="branchNumber" placeholder="Branch Number" /> -->
                            <nz-input-number formControlName="branchNumber" [nzMin]="000" [nzMax]="999" [nzStep]="1" style="width:100%"></nz-input-number>
                          </nz-form-control>
                        </div>
                        <div>
                          <nz-form-label [nzSpan]="24">Account Number</nz-form-label>
                          <nz-form-control [nzSpan]="24">            
                            <!-- <input nz-input formControlName="accountNum" placeholder="Account Number" /> -->
                            <nz-input-number formControlName="accountNum" [nzMin]="000000000" [nzMax]="999999999" [nzStep]="1" style="width:100%"></nz-input-number>
                          </nz-form-control>
                        </div>
                        <div>
                          <nz-form-label [nzSpan]="24">Account Currency</nz-form-label>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="accountCurrency" placeholder="Account Currency" disabled />
                          </nz-form-control>
                        </div>
                        <div>
                          <nz-form-label [nzSpan]="24">Bank Name and Branch</nz-form-label>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="bankNameAndBranch" placeholder="Bank Name and Branch" disabled />
                          </nz-form-control>
                        </div>
                        <div>
                          <nz-form-label [nzSpan]="24">Address</nz-form-label>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="address" placeholder="Address" disabled />
                          </nz-form-control>
                        </div>
                        <div>
                          <nz-form-label [nzSpan]="24">Country</nz-form-label>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="country" placeholder="Country" disabled />
                          </nz-form-control>
                        </div>
                        <div>
                          <nz-form-label [nzSpan]="24">Postal Code</nz-form-label>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="postalCode" placeholder="Postal Code" disabled />
                          </nz-form-control>
                        </div>
                      </div>
                
                  </div>
                </form>
                
                
                <form *ngIf="baseCompanyCountryCd == 'SINGAPORE'" [formGroup]="claimsBankDetailsForm"> 
                  <div class="bank-details-nominee-tab">
                    <div class="heading-tab">
                      <h3 class="heading">Account Details: {{claimsBankDetailsForm.get('accountHolderName').value}}</h3>
                    </div>
                    <div class="tab-grid">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Bank Name</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="bankName"/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Bank Code</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="bankCode"/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Branch Code</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="branchCode"/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Payment Method</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Payment Method" formControlName="paymentMethodCd">
                            <nz-option nzLabel="Cheque" nzValue="cheque"></nz-option>
                            <nz-option nzLabel="Bank Wire Transfer" nzValue="bankWireTransfer"></nz-option>
                          </nz-select>
                
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('paymentMethodCd').dirty || claimsBankDetailsForm.get('paymentMethodCd').touched) && claimsBankDetailsForm.get('paymentMethodCd').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('paymentMethodCd'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Name Of Account Holder</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="accountHolderName" (ngModelChange)="onNameChange($event,'EVENT')" />
                    
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('accountHolderName').dirty || claimsBankDetailsForm.get('accountHolderName').touched) && claimsBankDetailsForm.get('accountHolderName').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('accountHolderName'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                        
                      
                        <!-- <nz-form-label [nzSpan]="24">Retype Name Of Account Holder</nz-form-label> -->
                        <small class="d-b">Retype Name Of Account Holder</small>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="retypeAccountHolderName" (ngModelChange)="onNameChange($event,'RETYPE')" />
                          <nz-form-explain *ngIf="accNameCheck == false">
                            <p style="color:red">
                              Account Holder Name and Retype Account Holder Name is not matched
                            </p>
                    
                          </nz-form-explain>
                        </nz-form-control>
                      </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Bank Account No</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="accountNum" (ngModelChange)="onAccNoChange($event,'EVENT')" />
                
                          <nz-form-explain
                            *ngIf="(claimsBankDetailsForm.get('accountNum').dirty || claimsBankDetailsForm.get('accountNum').touched) && claimsBankDetailsForm.get('accountNum').errors">
                            <p style="color:red"
                              *ngFor="let error of validationUtilService.getUIErrorList(claimsBankDetailsForm.get('accountNum'), CLAIMSBANKDETAILSFORMNAME)">
                              {{error.errorMessage || error }}</p>
                          </nz-form-explain>
                
                          <small class="d-b">Retype Bank Account No</small>
                          <nz-form-control [nzSpan]="24">
                            <input nz-input formControlName="retypeaccountNum" (ngModelChange)="onAccNoChange($event,'RETYPE')" />
                            <nz-form-explain *ngIf="accNoCheck == false">
                              <p style="color:red">
                                Bank Account No and Retype Bank Account No is not matched
                              </p>
                            </nz-form-explain>
                
                          </nz-form-control>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Account Type</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Account Type" formControlName="accountType">
                            <nz-option nzLabel="Savings" nzValue="Savings"></nz-option>
                            <nz-option nzLabel="Current" nzValue="Current"></nz-option>
                            <nz-option nzLabel="Others" nzValue="Others"></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div class="tab-grid">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Sort Code</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="sortCode"/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Swift Code</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input maxlength="12" minlength="7" nz-input formControlName="swiftCode"/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">IBAN</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="IBAN"/>
                        </nz-form-control>
                      </nz-form-item>
                
                    </div>
                    <div class="m-b-20">
                      <h3>Bank Branch Address</h3>
                    </div>
                    <div class="tab-grid">
                      
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Address Line 1</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="addrLine1" disabled/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Town</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="town" disabled/>
                        </nz-form-control>
                      </nz-form-item>
                
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Country</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="country" disabled/>
                        </nz-form-control>
                      </nz-form-item>
                      
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Postal Code</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <input nz-input formControlName="postalCode" disabled/>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </div>
                </form>
              </div>
            </nz-tab>
          </nz-tabset>
        </div>
  
      </nz-tab>
    </ng-container>
  </nz-tabset>
  </div>
  
  